/*
 * File: /apps/web/src/util/trqs.js
 * Project: tr-web
 * Created Date: 2021-03-18
 * Author: Raif
 *
 * Copyright (c) 2021 TaskRabbit, Inc
 */
import qs from "qs";

const stringify = (data, options) => {
  return qs.stringify(data, { skipNulls: true, addQueryPrefix: true, ...options });
};

const decoder = (str, defaultEncoder, charset, type) => {
  if (type === "value") {
    if (str === "") {
      return null;
    }

    const num = Number(str);
    if (!Number.isNaN(num)) {
      return Number(str);
    }
    if (str === "true") {
      return true;
    }
    if (str === "false") {
      return false;
    }
  }
  return defaultEncoder(str);
};
const parse = (str, options = {}) => {
  let realStr = str;
  if (typeof str === "object") {
    realStr = stringify(str);
  }
  return qs.parse(realStr, { decoder, ignoreQueryPrefix: true, ...options });
};

export default { stringify, parse };
